import React from "react";
import { SOURCES } from "@/lib/constants";
import { FileText, Mail, FileCode2, Landmark, Smartphone, Inbox, ScanLine, Repeat, PencilLine, Building2 } from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS = {
  opplasting: FileText,
  epost: Mail,
  ehf: FileCode2,
  efaktura: Landmark,
  vipps: Smartphone,
  digipost: Inbox,
  eboks: Building2,
  papir: ScanLine,
  avtalegiro: Repeat,
  manuell: PencilLine,
};

export const SourceBadge = ({ source, className }) => {
  const Icon = ICONS[source] || FileText;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-md bg-secondary px-2 py-1 text-xs text-secondary-foreground whitespace-nowrap", className)} data-testid={`source-badge-${source}`}>
      <Icon className="h-3.5 w-3.5 text-muted-foreground" />
      {SOURCES[source] || source}
    </span>
  );
};
